import React, { useState } from 'react';
import './Faq.css';
import img1 from '../Components/Images/faq4.png';
import { Plus, Dash } from 'react-bootstrap-icons';
import { Helmet } from "react-helmet";

function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);
  
  const faqItems = [
    {
      question: "What types of products do you offer in Bahrain?",
      answer: "We offer a comprehensive range of industrial and retail equipment in Bahrain, including EAS security systems, CIJ inkjet printers, TTO printers, laser marking machines, POS systems, barcode scanners, weighing scales, and accessories. Our products are specifically chosen to meet the needs of Bahraini businesses across various sectors."
    },
    {
      question: "Do you provide installation and after-sales support in Bahrain?",
      answer: "Yes, we offer professional installation services throughout Bahrain for all our products. Our dedicated Bahrain-based support team provides maintenance, troubleshooting, and technical assistance to ensure your equipment operates smoothly. We understand the local market needs and provide timely support across all regions of Bahrain."
    },
    {
      question: "How do I choose the right printer or POS system for my Bahrain business?",
      answer: "Our Bahrain-based experts will help you select the perfect solution considering your industry, business size, usage requirements, and budget. Whether you're a retail store in Manama, a manufacturing facility in Sitra, or a logistics company in Hidd, we provide customized recommendations tailored for Bahrain's market conditions."
    },
    {
      question: "What warranty and service contracts do you offer in Bahrain?",
      answer: "All our products come with standard manufacturer warranty valid in Bahrain. We also provide extended service contracts and annual maintenance packages specifically designed for Bahrain's climate and business environment, ensuring your equipment remains operational year-round."
    }
  ];
  
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  
  return (
    <>
      <Helmet>
        <title>Frequently Asked Questions | POS & Security Solutions in Bahrain</title>
        <meta name="description" content="Get answers to common questions about our POS systems, security solutions, and industrial equipment in Bahrain. Learn about installation, support, and warranty services." />
        <meta name="keywords" content="POS Bahrain, security systems Bahrain, EAS Bahrain, printers Bahrain, barcode scanners Bahrain, retail equipment Bahrain, industrial equipment Bahrain" />
        <meta property="og:title" content="FAQ - POS & Security Solutions in Bahrain" />
        <meta property="og:description" content="Answers to common questions about our retail and industrial equipment solutions in Bahrain" />
        <link rel="canonical" href="https://www.yourwebsite.com/faq" />
      </Helmet>
      
      <section className="faq-section py-5" id="faq">
        <div className="container">
          <div className="header-section text-center">
            <h1 className="subtitle mb-2">FAQs</h1>
            <h2 className=" title mb-4">Frequently Asked Questions <br/>About Our Security, Code printing & POS Solutions in Bahrain</h2>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="faq-image">
                <img 
                  src={img1} 
                  alt="POS systems and security equipment FAQ Bahrain" 
                  className="img-fluid" 
                  loading="lazy"
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="faq-accordion-wrapper" itemScope itemType="https://schema.org/FAQPage">
                {faqItems.map((item, index) => (
                  <div 
                    className="faq-accordion-item" 
                    key={index}
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                  >
                    <div 
                      className={`faq-accordion-header ${activeIndex === index ? 'active' : ''}`} 
                      onClick={() => toggleAccordion(index)}
                    >
                      <h3 className="faq-accordion-title" itemProp="name">{item.question}</h3>
                      <div className="faq-icon-wrapper">
                        {activeIndex === index ? 
                          <Dash className="faq-icon" /> : 
                          <Plus className="faq-icon" />
                        }
                      </div>
                    </div>
                    <div 
                      className={`faq-accordion-content ${activeIndex === index ? 'active' : ''}`}
                      itemScope
                      itemProp="acceptedAnswer"
                      itemType="https://schema.org/Answer"
                    >
                      <div className="faq-answer-wrapper">
                        <p itemProp="text">{item.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Faq;